import { render, staticRenderFns } from "./HelpFooter.vue?vue&type=template&id=3e1c75fc&scoped=true"
import script from "./HelpFooter.vue?vue&type=script&lang=js"
export * from "./HelpFooter.vue?vue&type=script&lang=js"
import style0 from "./HelpFooter.vue?vue&type=style&index=0&id=3e1c75fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1c75fc",
  null
  
)

export default component.exports